import { HOST } from '../env'

/* eslint-disable import/prefer-default-export */
export async function useSponsorLogo() {
  let strapiData = ''
  const url = `https://strapi.cms.${HOST}/api/sponsor-logos?populate=deep`
  try {
    await fetch(url)
      .then(response => response.json())
      .then((result) => {
        if (result && result.data[0]) {
          strapiData = result?.data[0]?.attributes
          return strapiData
        }
        return null
      })
      .catch((error) => { throw error })
  } catch (e) {
    return null
  }
  return strapiData
}
